import { AlertCircle, RotateCcw } from 'lucide-react'

import { Button } from '@/components/ui/Button'

interface LazyErrorFallbackProps {
  error: Error
  onRetry: () => void
}

export function LazyErrorFallback({ error, onRetry }: LazyErrorFallbackProps) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-4">
          <AlertCircle className="w-10 h-10 text-red-500 dark:text-red-400" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Something went wrong
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          {error.message || 'An unexpected error occurred while loading this page.'}
        </p>
        <Button variant="secondary" onClick={onRetry}>
          <RotateCcw className="w-4 h-4 mr-1.5" />
          Try again
        </Button>
      </div>
    </div>
  )
}
